import { render, staticRenderFns } from "./EditReceiving.vue?vue&type=template&id=00822c80&"
import script from "./EditReceiving.vue?vue&type=script&lang=js&"
export * from "./EditReceiving.vue?vue&type=script&lang=js&"
import style0 from "./EditReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports